export const jobCategoryFilterData = data => {
  if (data?.length > 0) {
    let jobCat = data.map(item => ({
      label: labelChangeFunction(item),
      value: item,
    }))
    return jobCat
  }
}

export const labelChangeFunction = (label, plural) => {
  switch (label) {
    case 'PLACEMENT':
      return plural ? 'Placements' : 'Placement'
    case 'GIGS':
      return 'Gigs'
    case 'INTERNSHIP':
      return 'Internships'
    case 'INTERNSHIP_PPO':
      return 'Internship + PPO'
    case 'APPRENTICESHIP':
      return 'Apprenticeship'
  }
}

export const filterFunction = data => {
  if (Array.isArray(data)) {
    return data.flatMap(({ domain, degree }, domainIndex) => {
      if (Array.isArray(degree) && degree?.length > 0) {
        return degree?.flatMap(({ degree, department }, degreeIndex) => {
          if (Array.isArray(department) && department?.length > 0) {
            return department.flatMap(
              (
                { department: departmentName, specialization },
                departmentIndex
              ) => {
                if (
                  Array.isArray(specialization) &&
                  specialization?.length > 0
                ) {
                  return specialization.flatMap(
                    (
                      { specialization: specializationName },
                      specializationIndex
                    ) => {
                      return {
                        label: `${domain} - ${degree} - ${departmentName} - ${specializationName}`,
                        indices: {
                          domainIndex: domainIndex,
                          degreeIndex: degreeIndex,
                          departmentIndex: departmentIndex,
                          specializationIndex: specializationIndex,
                        },
                      }
                    }
                  )
                } else {
                  return {
                    label: `${domain} - ${degree} - ${departmentName}`,
                    indices: {
                      domainIndex: domainIndex,
                      degreeIndex: degreeIndex,
                      departmentIndex: departmentIndex,
                    },
                  }
                }
              }
            )
          } else {
            return {
              label: `${domain} - ${degree}`,
              indices: {
                domainIndex: domainIndex,
                degreeIndex: degreeIndex,
              },
            }
          }
        })
      } else {
        return {
          label: `${domain}`,
          indices: {
            domainIndex: domainIndex,
          },
        }
      }
    })
  }
}

export const pdfFormatFunction = data => {
  if (!Array.isArray(data)) return []

  const capitalizeFirstLetter = str => {
    if (!str) return ''
    return str
      .toLowerCase() // Convert to lowercase first
      .split(' ') // Split into words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
      .join(' ') // Join back into a string
  }

  return data.map(({ domain, degree }, domainIndex) => {
    const joinLabel =
      Array.isArray(degree) && degree.length > 0
        ? degree.flatMap(({ degree, department }, degreeIndex) => {
            if (Array.isArray(department) && department.length > 0) {
              return department.flatMap(
                (
                  { department: departmentName, specialization },
                  departmentIndex
                ) => {
                  if (
                    Array.isArray(specialization) &&
                    specialization.length > 0
                  ) {
                    return specialization.map(
                      (
                        { specialization: specializationName },
                        specializationIndex
                      ) => ({
                        label: capitalizeFirstLetter(
                          ` ${degree} - ${departmentName} - ${specializationName}`
                        ),
                        indices: {
                          domainIndex,
                          degreeIndex,
                          departmentIndex,
                          specializationIndex,
                        },
                      })
                    )
                  } else {
                    return {
                      label: capitalizeFirstLetter(
                        ` ${degree} - ${departmentName}`
                      ),
                      indices: { domainIndex, degreeIndex, departmentIndex },
                    }
                  }
                }
              )
            } else {
              return {
                label: capitalizeFirstLetter(` ${degree}`),
                indices: { domainIndex, degreeIndex },
              }
            }
          })
        : []

    return {
      label: capitalizeFirstLetter(domain),
      indices: { domainIndex },
      joinLabel,
    }
  })
}

export const mapping = (key, text = '') => {
  const data = {
    upcoming: { label: 'Upcoming', bg: '#C1C1C1', rgb: [193, 193, 193] },
    evaluationInProgress: {
      label: 'Evaluation in Progress',
      bg: '#F7B400',
      rgb: [247, 180, 0],
    },
    completed: { label: 'Completed', bg: '#0FB680', rgb: [15, 182, 128] },
    applicationClosed: {
      label: 'Application Closed',
      bg: '#000000',
      rgb: [0, 0, 0],
    },
    openForApplication: {
      label: (text === 'Role' ? '' : text ?? '') + ' Open for Application',
      bg: '#3249D7',
      rgb: [50, 73, 215],
    },
    roleClosed: {
      label: (text ?? '') + ' Closed',
      bg: '#F54B56',
      rgb: [245, 75, 86],
    },
  }

  return data[key] || { label: key, bg: '' }
}

export const activeJobRolesMapping = {
  intern_to_offer: 'Intern To Offer',
  evaluation_in_progress: 'Evaluation in Progress',
  absent_status: 'Absent Status',
  offer_accepted: 'Offer Accepted',
  offer_declined: 'Offer Declined',
  offer_released: 'Offer Released',
  rejected: 'Rejected',
}

export const keysToMapInActiveJobRoles = [
  'applied_student',
  'evaluation_in_progress',
  'rejected',
  'intern_to_offer',
  'offer_released',
  'offer_accepted',
  'offer_declined',
  'absent_status',
]

export const capitalizeText = text => {
  return text
    .replace(/_/g, ' ') // Replace underscores with spaces
    .replace(/\b\w/g, char => char.toUpperCase()) // Capitalize each word
}

export const getStatusWithBG = (key, text = '') => {
  const statusMap = {
    intern_to_offer: {
      label: (text ?? '') + ' ' + 'Intent To Offer',
      backgroundColor: '#5dade2',
    }, // Gold
    evaluation_in_progress: {
      label: 'In Evaluation Process',
      backgroundColor: '#d3d3d3',
    }, // Sky Blue
    absent_status: { label: 'Absent', backgroundColor: '#000000' }, // Light Salmon
    offer_accepted: {
      label: (text ?? '') + ' ' + 'Offer Accepted',
      backgroundColor: '#27ae60',
    }, // Lime Green
    offer_declined: {
      label: (text ?? '') + ' ' + 'Offer Declined',
      backgroundColor: '#e74c3c',
    }, // Orange Red
    rejected: { label: 'Rejected', backgroundColor: '#f39c12' }, // Crimson
    offer_released: {
      label: (text ?? '') + ' ' + 'Offer Released',
      backgroundColor: '#556BD9',
    },
    applied_student: { label: 'Applied', backgroundColor: '#606060' },
  }
  return statusMap[key] || { label: key, backgroundColor: '#D3D3D3' } // Default Gray for unknown keys
}

export const statusColors = {
  upcoming: [193, 193, 193], // Orange
  'open for application': [50, 73, 215], // Green
  'role closed': [245, 75, 86], // Red
  'evaluation in progress': [247, 180, 0], // Blue
  'application closed': [0, 0, 0], // Gray
  completed: [15, 182, 128],
  placed: [15, 182, 128],
  'un-placed': [245, 75, 86],
  'opt-out': [107, 114, 128],
  selected: [15, 182, 128],
  'un-selected': [245, 75, 86],
}

export const ctcAnalysisColors = [
  [30, 144, 255],
  [28, 169, 201],
  [149, 162, 231],
  [125, 249, 255],
  [118, 215, 196],
  [0, 71, 171],
  [0, 191, 255],
  [70, 130, 180],
]

export const ctcAnalysisGraphColors = [
  '#1E90FF',
  '#1CA9C9',
  '#556BD9',
  '#0047AB',
  '#7DF9FF',
  '#00BFFF',
  '#76D7C4',
  '#4682B4',
]

export const ruleEngineColors = [
  [250, 250, 251],
  [224, 247, 255],
  [231, 224, 255],
  [255, 229, 237],
  [242, 159, 5],
  [242, 92, 5],
  [114, 176, 111],
  [76, 29, 145],
  [2, 69, 122],
  [89, 95, 51],
]

export const ruleEngineGraphColors = [
  '#FAFAFB',
  '#E0F7FF',
  '#E7E0FF',
  '#FFE5ED',
  '#F29F0533',
  '#F25C0533',
  '#72B06F33',
  '#4C1D9133',
  '#02457A33',
  '#595F3333',
]

export const ctcCategoryColors = [
  [30, 144, 255],
  [85, 107, 217],
  [118, 215, 196],
  [125, 249, 255],
]

export function capitalizeFirstLetter(text) {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
}

export function formatLPA(amount, round = false) {
  if (amount < 100000) return amount.toString()
  const lpa = amount / 100000
  return round ? lpa?.toFixed(2) + 'LPA' : lpa?.toFixed(2)
}

export const formatStudentCount = (total, male, female, others) => {
  const details = [
    male ? `${male}M` : '',
    female ? `${female}F` : '',
    others ? `${others} Others` : '',
  ]
    .filter(Boolean)
    .join(' / ')

  return total > 0 ? `${total}${details ? ` (${details})` : ''}` : '0'
}
export const formatRange = (start, end, packagePeriod) => {
  if (start === end) {
    return `${start} ${packagePeriod}`
  } else {
    return `${start} ${packagePeriod} - ${end} ${packagePeriod}`
  }
}

export const calculateYAxisScale = count => {
  let roundedMax, stepSize

  if (count >= 100) {
    let nearestHundred = Math.ceil(count / 100) * 100
    let nearestFifty = Math.ceil(count / 50) * 50

    // Check if count is odd or below 50% of the nearest hundred
    if (count % 2 !== 0 || count >= nearestHundred * 0.5) {
      roundedMax = nearestHundred
    } else {
      roundedMax = nearestFifty
    }
  } else {
    // Round to the nearest multiple of 5
    roundedMax = Math.ceil(count / 5) * 5
  }

  // Split into 5 equal intervals
  stepSize = roundedMax / 5

  return { roundedMax, stepSize }
}
